import { AnimationCel, CelWaste } from "../../../../content/posts/coding-and-traditional-animation/sketch.js";
import * as React from 'react';
export default {
  AnimationCel,
  CelWaste,
  React
};